"use strict";

const { breakpoints } = require("../helpers/breakpoints");
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';

// CONSTANTS
const DEFAULTS = {
    SLIDES_TO_SHOW: 5,
    SLIDES_TO_SHOW_MOBILE: 2,
    SPACING_IN_PIXEL: 16,
};

export function initializeCarousel(swiperSelector, options = {}) {
    let carousels = [];
    // Iterate over each element that matches the selector
    $(swiperSelector).each(function() {
        const $this = $(this);

        if ($this[0].swiper) {
            return;
        }

        // Helper function to safely parse data attributes
        const parseDataAttribute = (attribute, defaultValue) => {
            const value = parseFloat($this.data(attribute));
            return isNaN(value) ? defaultValue : value;
        };

        // Extract configuration from data attributes
        const dataConfig = {
            slidesToShowSmall: parseDataAttribute("slides-to-show-mobile", DEFAULTS.SLIDES_TO_SHOW_MOBILE),
            slidesToShowMedium: parseDataAttribute("slides-to-show-medium", parseDataAttribute("slides-to-show", DEFAULTS.SLIDES_TO_SHOW)),
            slidesToShowLarge: parseDataAttribute("slides-to-show-large", parseDataAttribute("slides-to-show", DEFAULTS.SLIDES_TO_SHOW)),
            slidesToShowExtraLarge: parseDataAttribute("slides-to-show", DEFAULTS.SLIDES_TO_SHOW),
            spacing: parseDataAttribute("spacing", DEFAULTS.SPACING_IN_PIXEL),
            spacingMobile: parseDataAttribute("spacing-mobile", DEFAULTS.SPACING_IN_PIXEL),
            autoplay: $this.data("autoplay"),
            autoplayDelay: $this.data("autoplay-delay"),
            loopEnabled: Boolean($this.data("loop-enabled")),
            navEnabled: Boolean($this.data("navigation-enabled")),
            paginationEnabled: Boolean($this.data("pagination-enabled")),
            scrollbarEnabled: Boolean($this.data("scroll-enabled")),
            direction: $this.data("direction") || "horizontal",
            clickablePagination: Boolean($this.data("clickable-pagination")),
            centerInsufficientSlides: Boolean($this.data("center-insuficient-slides")),
            paginationType: $this.data("pagination-type") || "bullets",
            observer: Boolean($this.data("mutation-observer")),
            hasProductTiles: Boolean($this.find("[data-recommender]").length > 0 || $this.find(".product[data-pid]").length > 0 || $this.find(".card.product-info").length > 0),
            widthConstrained: Boolean($this.data("width-constrained"))
        };

        // Destructure dataConfig for easier access
        const {
            slidesToShowSmall,
            slidesToShowMedium,
            slidesToShowLarge,
            slidesToShowExtraLarge,
            spacing,
            spacingMobile,
            autoplay,
            autoplayDelay,
            loopEnabled,
            navEnabled,
            paginationEnabled,
            scrollbarEnabled,
            direction,
            clickablePagination,
            centerInsufficientSlides,
            paginationType,
            observer,
            hasProductTiles,
            widthConstrained
        } = dataConfig;

        // Base configuration
        const baseConfig = {
            loop: loopEnabled,
            modules: [
                navEnabled && Navigation,
                paginationEnabled && Pagination,
                scrollbarEnabled && Scrollbar,
                autoplay && Autoplay
            ].filter(Boolean),
            direction,
            watchSlidesProgress: true,
            centerInsufficientSlides,
            pagination: {
                el: `${swiperSelector} .swiper-pagination`,
                type: paginationType,
                clickable: clickablePagination,
            },
            navigation: {
                nextEl: `${swiperSelector} .swiper-button-next`,
                prevEl: `${swiperSelector} .swiper-button-prev`,
            },
            scrollbar: {
                el: `${swiperSelector} .swiper-scrollbar`,
            },
            slidesPerView: slidesToShowSmall,
            spaceBetween: spacingMobile,
            breakpoints: {
                [breakpoints.md]: {
                    slidesPerView: slidesToShowMedium,
                    spaceBetween: spacing,
                },
                [breakpoints.lg]: {
                    slidesPerView: slidesToShowLarge,
                    spaceBetween: spacing,
                },
                [breakpoints.xl]: {
                    slidesPerView: slidesToShowExtraLarge,
                    spaceBetween: spacing,
                }
            },
            ...(autoplay && autoplayDelay && {
                autoplay: {
                    delay: autoplayDelay,
                    pauseOnMouseEnter: true
                }
            }),
            ...(observer && {
                observer: true
            }),
            on: {
                init() {
                    $("body").trigger("carousel:initialized");
                    $this.removeSkeleton();
                }
            }
        };

        function incrementSlidesPerView(increment) {
            return Math.min(Math.floor(slidesToShowSmall) + increment, slidesToShowExtraLarge);
        }

        // Conditional breakpoints if hasProductTiles is true
        const productTilesBreakpoints = hasProductTiles ? {
            [breakpoints.md]: {
                slidesPerView: !widthConstrained ? incrementSlidesPerView(1) : slidesToShowSmall,
                spaceBetween: spacing,
            },
            [breakpoints.lg]: {
                slidesPerView: !widthConstrained ? incrementSlidesPerView(2) : incrementSlidesPerView(1),
                spaceBetween: spacing,
            },
            [breakpoints.xl]: {
                slidesPerView: slidesToShowExtraLarge,
                spaceBetween: spacing,
            }
        } : {};

        // Merge options into baseConfig, allowing options to override
        const config = {
            ...baseConfig,
            ...options,
            breakpoints: {
                ...baseConfig.breakpoints,
                ...productTilesBreakpoints,
                ...(options.breakpoints || {})
            }
        };

        var newSwiper = new Swiper($this[0], config);
        carousels.push(newSwiper);
        return newSwiper;
    });
    return carousels;
}
